import { getEdition } from "./editions";

export const FIXED_PROMO_EDITION_SLUG = "saopaulo-2026";

const fixedEdition = getEdition(FIXED_PROMO_EDITION_SLUG);

export const FIXED_PROMO_EDITION = {
  slug: fixedEdition.slug,
  label: `${fixedEdition.city} (${fixedEdition.editionDates})`,
} as const;

export const PROMO_PARTICIPATION_ROLE_KEYS = [
  "palestrante",
  "coordenador",
  "workshop",
  "forum",
  "hub-de-mentorias",
  "patrocinador",
] as const;

export const PROMO_PARTICIPATION_TYPES = [
  { role: "palestrante", label: "Trilha", badgeLabel: "PALESTRA", color: "#004c94" },
  { role: "coordenador", label: "Coordenação", badgeLabel: "COORDENAÇÃO", color: "#f3b633" },
  { role: "workshop", label: "Workshops", badgeLabel: "WORKSHOPS", color: "#5c0f8b" },
  { role: "forum", label: "Fórum", badgeLabel: "FÓRUM", color: "#f3b633" },
  {
    role: "hub-de-mentorias",
    label: "Hub de Mentorias",
    badgeLabel: "HUB DE MENTORIAS",
    color: "#e35100",
  },
  { role: "patrocinador", label: "Patrocinador", badgeLabel: "PATROCINADOR", color: "#aa1e0d" },
] as const;

export type PromoParticipationRole = (typeof PROMO_PARTICIPATION_ROLE_KEYS)[number];

/** Floripa-only keys kept so previously queued rows still validate. */
export const LEGACY_FLORIPA_ONLY_TRILHA_KEYS = [
  "agentic-ai",
  "javascript-e-node-js",
  "quality-engineering-e-ai-testing",
  "engenharia-de-ia-e-ml",
  "rh-agil",
  "gen-ai-e-llms",
  "engenharia-de-dados-e-analytics",
] as const;

export const PROMO_TRILHA_KEYS = [
  "gestao-agil-e-lideranca-de-impacto",
  "arquitetura-cloud",
  "governanca-de-ia",
  "engenharia-de-dados",
  "ai-code-e-automacao",
  "apis-e-microservices",
  "design-e-estrategia-de-produto",
  "testes-e-quality-management",
  "forum-startup",
  "stadium-quarta",
  "workshops-quarta",
  "hub-de-mentorias-quarta",
  "community-lounge-quarta",
  "agilidade-com-genai",
  "sre-e-observabilidade",
  "engenharia-de-ia",
  "data-science-e-analytics",
  "design-de-codigo",
  "arquitetura-de-solucoes",
  "gestao-de-produtos-e-growth",
  "devtest-e-ia",
  "forum-executivo",
  "stadium-quinta",
  "workshops-quinta",
  "hub-de-mentorias-quinta",
  "community-lounge-quinta",
  "tech-essentials",
  "software-security",
  "agentes-de-ia",
  "physical-ai",
  "arquitetura-java",
  "lideranca-tecnica",
  "ux-design-research-e-metricas",
  "front-end-moderno-e-arquitetura-web",
  "ai-e-emerging-tech",
  "stadium-sexta",
  "workshops-sexta",
  "hub-de-mentorias-sexta",
  "community-lounge-sexta",
  "bradesco",
  "oracle",
  "aws",
  "microsoft",
  "ibm",
  "cognizant",
  "bosch",
  "codejobs",
  "fiap",
  "neo4j",
] as const;

export const DEFAULT_TRILHA_KEY = PROMO_TRILHA_KEYS[0];

export type PromoTrilhaKey = (typeof PROMO_TRILHA_KEYS)[number];

export type PromoTrilhaKind =
  | "palestra"
  | "workshop"
  | "forum"
  | "hub-de-mentorias"
  | "community-lounge"
  | "stadium"
  | "patrocinador";

export type PromoTrilha = {
  key: PromoTrilhaKey;
  label: string;
  dateLabel: string;
  selectLabel: string;
  kind: PromoTrilhaKind;
  color: string;
  /** When set, the composition shows this logo instead of the trilha-name badge. */
  logoAsset?: string;
};

export const PROMO_TRILHAS = [
  {
    key: "gestao-agil-e-lideranca-de-impacto",
    label: "Gestão Ágil e Liderança de impacto",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Gestão Ágil e Liderança de impacto",
    kind: "palestra",
    color: "#c22821",
  },
  {
    key: "arquitetura-cloud",
    label: "Arquitetura Cloud",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Arquitetura Cloud",
    kind: "palestra",
    color: "#152a3f",
  },
  {
    key: "governanca-de-ia",
    label: "Governança de IA",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Governança de IA",
    kind: "palestra",
    color: "#3e984c",
  },
  {
    key: "engenharia-de-dados",
    label: "Engenharia de Dados",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Engenharia de Dados",
    kind: "palestra",
    color: "#3e984c",
  },
  {
    key: "ai-code-e-automacao",
    label: "AI Code & Automação",
    dateLabel: "23/SET",
    selectLabel: "23/SET - AI Code & Automação",
    kind: "palestra",
    color: "#004c94",
  },
  {
    key: "apis-e-microservices",
    label: "APIs e Microservices",
    dateLabel: "23/SET",
    selectLabel: "23/SET - APIs e Microservices",
    kind: "palestra",
    color: "#004c94",
  },
  {
    key: "design-e-estrategia-de-produto",
    label: "Design e Estratégia de Produto",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Design e Estratégia de Produto",
    kind: "palestra",
    color: "#5c0f8b",
  },
  {
    key: "testes-e-quality-management",
    label: "Testes e Quality Management",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Testes e Quality Management",
    kind: "palestra",
    color: "#43273b",
  },
  {
    key: "forum-startup",
    label: "Fórum Startup",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Fórum Startup",
    kind: "forum",
    color: "#f3b633",
  },
  {
    key: "stadium-quarta",
    label: "STADIUM QUARTA",
    dateLabel: "23/SET",
    selectLabel: "23/SET - STADIUM QUARTA",
    kind: "stadium",
    color: "#1c1c1c",
  },
  {
    key: "workshops-quarta",
    label: "Workshops",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Workshops",
    kind: "workshop",
    color: "#5c0f8b",
  },
  {
    key: "hub-de-mentorias-quarta",
    label: "Hub de Mentorias",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Hub de Mentorias",
    kind: "hub-de-mentorias",
    color: "#e35100",
  },
  {
    key: "community-lounge-quarta",
    label: "Community Lounge",
    dateLabel: "23/SET",
    selectLabel: "23/SET - Community Lounge",
    kind: "community-lounge",
    color: "#dc2597",
  },
  {
    key: "agilidade-com-genai",
    label: "Agilidade com GenAI",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Agilidade com GenAI",
    kind: "palestra",
    color: "#c22821",
  },
  {
    key: "sre-e-observabilidade",
    label: "SRE e Observabilidade",
    dateLabel: "24/SET",
    selectLabel: "24/SET - SRE e Observabilidade",
    kind: "palestra",
    color: "#152a3f",
  },
  {
    key: "engenharia-de-ia",
    label: "Engenharia de IA",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Engenharia de IA",
    kind: "palestra",
    color: "#3e984c",
  },
  {
    key: "data-science-e-analytics",
    label: "DataScience e Analytics",
    dateLabel: "24/SET",
    selectLabel: "24/SET - DataScience e Analytics",
    kind: "palestra",
    color: "#3e984c",
  },
  {
    key: "design-de-codigo",
    label: "Design de Código",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Design de Código",
    kind: "palestra",
    color: "#004c94",
  },
  {
    key: "arquitetura-de-solucoes",
    label: "Arquitetura de Soluções",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Arquitetura de Soluções",
    kind: "palestra",
    color: "#004c94",
  },
  {
    key: "gestao-de-produtos-e-growth",
    label: "Gestão de Produtos e Growth",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Gestão de Produtos e Growth",
    kind: "palestra",
    color: "#5c0f8b",
  },
  {
    key: "devtest-e-ia",
    label: "DevTest e IA",
    dateLabel: "24/SET",
    selectLabel: "24/SET - DevTest e IA",
    kind: "palestra",
    color: "#43273b",
  },
  {
    key: "forum-executivo",
    label: "Fórum Executivo",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Fórum Executivo",
    kind: "forum",
    color: "#f3b633",
  },
  {
    key: "stadium-quinta",
    label: "STADIUM QUINTA",
    dateLabel: "24/SET",
    selectLabel: "24/SET - STADIUM QUINTA",
    kind: "stadium",
    color: "#1c1c1c",
  },
  {
    key: "workshops-quinta",
    label: "Workshops",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Workshops",
    kind: "workshop",
    color: "#5c0f8b",
  },
  {
    key: "hub-de-mentorias-quinta",
    label: "Hub de Mentorias",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Hub de Mentorias",
    kind: "hub-de-mentorias",
    color: "#e35100",
  },
  {
    key: "community-lounge-quinta",
    label: "Community Lounge",
    dateLabel: "24/SET",
    selectLabel: "24/SET - Community Lounge",
    kind: "community-lounge",
    color: "#dc2597",
  },
  {
    key: "tech-essentials",
    label: "Tech Essentials (Estudantes)",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Tech Essentials (Estudantes)",
    kind: "palestra",
    color: "#e35100",
  },
  {
    key: "software-security",
    label: "Software Security",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Software Security",
    kind: "palestra",
    color: "#152a3f",
  },
  {
    key: "agentes-de-ia",
    label: "Agentes de IA",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Agentes de IA",
    kind: "palestra",
    color: "#3e984c",
  },
  {
    key: "physical-ai",
    label: "Physical AI",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Physical AI",
    kind: "palestra",
    color: "#3e984c",
  },
  {
    key: "arquitetura-java",
    label: "Arquitetura Java",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Arquitetura Java",
    kind: "palestra",
    color: "#004c94",
  },
  {
    key: "lideranca-tecnica",
    label: "Liderança Técnica",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Liderança Técnica",
    kind: "palestra",
    color: "#004c94",
  },
  {
    key: "ux-design-research-e-metricas",
    label: "UX Design, Research e Métricas",
    dateLabel: "25/SET",
    selectLabel: "25/SET - UX Design, Research e Métricas",
    kind: "palestra",
    color: "#5c0f8b",
  },
  {
    key: "front-end-moderno-e-arquitetura-web",
    label: "Front-end Moderno e Arquitetura Web",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Front-end Moderno e Arquitetura Web",
    kind: "palestra",
    color: "#3b693c",
  },
  {
    key: "ai-e-emerging-tech",
    label: "AI & Emerging Tech (Internacional)",
    dateLabel: "25/SET",
    selectLabel: "25/SET - AI & Emerging Tech (Internacional)",
    kind: "palestra",
    color: "#e35100",
  },
  {
    key: "stadium-sexta",
    label: "STADIUM SEXTA",
    dateLabel: "25/SET",
    selectLabel: "25/SET - STADIUM SEXTA",
    kind: "stadium",
    color: "#1c1c1c",
  },
  {
    key: "workshops-sexta",
    label: "Workshops",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Workshops",
    kind: "workshop",
    color: "#5c0f8b",
  },
  {
    key: "hub-de-mentorias-sexta",
    label: "Hub de Mentorias",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Hub de Mentorias",
    kind: "hub-de-mentorias",
    color: "#e35100",
  },
  {
    key: "community-lounge-sexta",
    label: "Community Lounge",
    dateLabel: "25/SET",
    selectLabel: "25/SET - Community Lounge",
    kind: "community-lounge",
    color: "#dc2597",
  },
  {
    key: "bradesco",
    label: "Bradesco",
    dateLabel: "",
    selectLabel: "Bradesco",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/bradesco.png",
  },
  {
    key: "oracle",
    label: "Oracle",
    dateLabel: "",
    selectLabel: "Oracle",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/oracle.png",
  },
  {
    key: "aws",
    label: "AWS",
    dateLabel: "",
    selectLabel: "AWS",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/aws.png",
  },
  {
    key: "microsoft",
    label: "Microsoft",
    dateLabel: "",
    selectLabel: "Microsoft",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/microsoft.png",
  },
  {
    key: "ibm",
    label: "IBM",
    dateLabel: "",
    selectLabel: "IBM",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/ibm.png",
  },
  {
    key: "cognizant",
    label: "Cognizant",
    dateLabel: "",
    selectLabel: "Cognizant",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/cognizant.png",
  },
  {
    key: "bosch",
    label: "Bosch",
    dateLabel: "",
    selectLabel: "Bosch",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/bosch.png",
  },
  {
    key: "codejobs",
    label: "Codejobs",
    dateLabel: "",
    selectLabel: "Codejobs",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/codejobs.png",
  },
  {
    key: "fiap",
    label: "FIAP",
    dateLabel: "",
    selectLabel: "FIAP",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/fiap.png",
  },
  {
    key: "neo4j",
    label: "Neo4j",
    dateLabel: "",
    selectLabel: "Neo4j",
    kind: "patrocinador",
    color: "#aa1e0d",
    logoAsset: "/logos/patrocinadores/neo4j.png",
  },
] satisfies readonly PromoTrilha[];

const TRILHA_KINDS_BY_PARTICIPATION_TYPE: Record<
  PromoParticipationRole,
  readonly PromoTrilhaKind[]
> = {
  palestrante: ["palestra", "community-lounge", "stadium", "patrocinador"],
  coordenador: [],
  workshop: ["workshop"],
  forum: ["forum"],
  "hub-de-mentorias": ["hub-de-mentorias"],
  patrocinador: ["patrocinador"],
};

const DATE_ONLY_PARTICIPATION_TYPES: readonly PromoParticipationRole[] = [
  "workshop",
  "forum",
  "hub-de-mentorias",
];

export function usesDateOnlyTrilhaDisplay(role: PromoParticipationRole): boolean {
  return DATE_ONLY_PARTICIPATION_TYPES.includes(role);
}

export function getTrilhasForParticipationType(role: PromoParticipationRole): readonly PromoTrilha[] {
  const acceptedKinds = TRILHA_KINDS_BY_PARTICIPATION_TYPE[role];
  if (acceptedKinds.length === 0) return [];
  return PROMO_TRILHAS.filter((trilha) => acceptedKinds.includes(trilha.kind));
}

export function getDefaultTrilhaForParticipationType(
  role: PromoParticipationRole,
): PromoTrilhaKey | null {
  return getTrilhasForParticipationType(role)[0]?.key ?? null;
}

export function getParticipationTypeLabel(role: PromoParticipationRole): string {
  return PROMO_PARTICIPATION_TYPES.find((option) => option.role === role)?.label ?? role;
}

export function getTrilhaDisplayLabel(role: PromoParticipationRole, trilha: PromoTrilha): string {
  return usesDateOnlyTrilhaDisplay(role) ? trilha.dateLabel : trilha.selectLabel;
}

export function getTrilhaTemplateDateLabel(
  role: PromoParticipationRole,
  key: string | undefined,
): string | null {
  if (!key) return null;
  const trilha = getTrilhasForParticipationType(role).find((option) => option.key === key);
  return trilha?.dateLabel || null;
}

function normalizeSearchText(value: string): string {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function filterTrilhasForSearch(
  options: readonly PromoTrilha[],
  query: string,
): readonly PromoTrilha[] {
  const normalizedQuery = normalizeSearchText(query.trim());
  if (!normalizedQuery) return options;

  return options.filter((trilha) =>
    normalizeSearchText(`${trilha.dateLabel} ${trilha.label} ${trilha.selectLabel}`).includes(
      normalizedQuery,
    ),
  );
}
